import { css } from '@emotion/react';
import { applyFont, tokens } from '@domain-group/fe-brary';
import { media } from '../../styles/breakpoints-2026';

const { colors, spacing, typography } = tokens;

export const overview = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing.l};
`;

export const profileDetails = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing.xxs};
`;

export const name = css`
  ${applyFont(typography.displayMedium)}
  color: ${colors.neutral.heavy.default};
  margin: 0;

  ${media('<tablet')} {
    ${applyFont(typography.heading)}
    line-height: 28px;
  }
`;

export const roleAndAgency = css`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing.xs};

  ${media('>=tablet', '<=tablet-narrow')} {
    min-width: 0;
    flex-wrap: nowrap;
  }
`;

export const stackedRoleAndAgency = css`
  align-items: flex-start;
  flex-direction: column;
  gap: ${spacing.xxs};
`;

export const role = css`
  ${applyFont(typography.body)}
  color: ${colors.neutral.medium.default};

  ${media('>=tablet', '<=tablet-narrow')} {
    flex: 0 0 auto;
  }
`;

export const agencyLink = css`
  ${applyFont(typography.body)}
  color: ${colors.neutral.medium.default};
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;

  ${media('<tablet')} {
    display: none;
  }

  ${media('>=tablet', '<=tablet-narrow')} {
    flex: 1 1 auto;
    white-space: nowrap;
  }
`;

export const separator = css`
  ${applyFont(typography.body)}
  color: ${colors.neutral.medium.default};

  ${media('<tablet')} {
    display: none;
  }

  ${media('>=tablet', '<=tablet-narrow')} {
    flex: 0 0 auto;
  }
`;

export const ratingRow = css`
  ${applyFont(typography.body)}
  align-items: center;
  background: none;
  border: 0;
  color: ${colors.neutral.medium.default};
  cursor: pointer;
  display: inline-flex;
  gap: ${spacing.xxs};
  justify-content: flex-start;
  line-height: 28px;
  margin: 0;
  padding: 0;
  text-align: left;
  white-space: nowrap;
  width: fit-content;

  ${media('>=tablet', '<=tablet-narrow')} {
    line-height: 24px;
    padding-top: ${spacing.xxs};
  }
`;

export const ratingStar = css`
  color: ${colors.accentFour.trim.hover};
  flex: 0 0 auto;
  height: 20px;
  width: 20px;
`;

export const ratingText = css`
  text-align: center;
`;

export const ratingSeparator = css`
  color: ${colors.neutral.trim.default};
`;

export const badges = css`
  align-items: center;
  display: flex;
  gap: ${spacing.m};
  padding-top: ${spacing.xxs};

  ${media('>=tablet', '<=tablet-narrow')} {
    gap: ${spacing.s};
    padding-top: ${spacing.xs};
  }

  > span {
    align-items: center;
    box-sizing: border-box;
    display: inline-flex;
    height: 24px;
    padding: 2px ${spacing.xs};
  }
`;

export const reinswIcon = css`
  color: currentColor;
  height: 20px;
  margin-left: ${spacing.xxs};
  width: 20px;
`;
